module.exports = __webpack_public_path__ + "img/Science_Outline.b032d87a.svg";